// src/components/navigation/ArtistNav.tsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar, Toolbar, Button, Menu, MenuItem, Box, IconButton,
  Typography, Divider, Avatar,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ShowrunnrLogo from '../ShowrunnrLogo';
import { useAuth } from '../../contexts/AuthContext';

const ArtistNav: React.FC = () => {
  const { user, logout } = useAuth();
  const [moreAnchor, setMoreAnchor] = useState<null | HTMLElement>(null);
  const [userAnchor, setUserAnchor] = useState<null | HTMLElement>(null);

  const musicianPath = user?.name
    ? `/musician/${encodeURIComponent(user.name)}`
    : '/artist/profile';

  const initials = user?.name
    ? user.name.split(' ').map((n: string) => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  return (
    <AppBar position="static" color="primary">
      <Toolbar sx={{ justifyContent: 'space-between', gap: 1 }}>
        {/* Logo + nav links grouped left */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <ShowrunnrLogo width={150} height={50} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Button color="inherit" component={Link} to="/artist/dashboard">
            My Dashboard
          </Button>

          <Button color="inherit" component={Link} to={musicianPath}>
            My Profile
          </Button>

          {/* More — Pomodoro only for now */}
          <Button
            color="inherit"
            onClick={(e) => setMoreAnchor(e.currentTarget)}
            endIcon={<ArrowDropDownIcon />}
          >
            More
          </Button>
          <Menu
            anchorEl={moreAnchor}
            open={Boolean(moreAnchor)}
            onClose={() => setMoreAnchor(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            <MenuItem component={Link} to="/musicadmin" onClick={() => setMoreAnchor(null)}>
              Pomodoro
            </MenuItem>
          </Menu>
        </Box>
        </Box>{/* end logo+links group */}

        {/* User avatar + dropdown */}
        <Box>
          <IconButton onClick={(e) => setUserAnchor(e.currentTarget)} size="small" sx={{ p: 0.5 }}>
            <Avatar sx={{ width: 34, height: 34, bgcolor: 'rgba(255,255,255,0.2)', fontSize: '0.8rem', color: 'white' }}>
              {initials}
            </Avatar>
          </IconButton>
          <Menu
            anchorEl={userAnchor}
            open={Boolean(userAnchor)}
            onClose={() => setUserAnchor(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{ sx: { minWidth: 200 } }}
          >
            <Box sx={{ px: 2, py: 1.5 }}>
              <Typography variant="body2" fontWeight={600} noWrap>{user?.name || '—'}</Typography>
              <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
                {user?.email}
              </Typography>
            </Box>
            <Divider />
            <MenuItem onClick={logout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default ArtistNav;
